import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import htmlToPdfmake from 'html-to-pdfmake'
pdfMake.vfs = pdfFonts.pdfMake?.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'https://fronts.skyict.co.th/Sarabun-Light.ttf',
    bold: 'https://fronts.skyict.co.th/Sarabun-Bold.ttf',
    italics: 'https://fronts.skyict.co.th/Sarabun-Italic.ttf',
    bolditalics: 'https://fronts.skyict.co.th/Sarabun-BoldItalic.ttf'
  }
}
export { pdfMake, htmlToPdfmake }
